import NewCoursePage from "@/components/screens/course/new";

export default function NewCourse() {
  return <NewCoursePage />;
}
